<template>
  <div class="mobile-dashboard">
    <main>
    <div class="left-panel">
      <SidebarMobile />
    </div>
    <div class="right-panel">
      <HeaderMobile />
      <div class="right-panel-view">
        <router-view />
      </div>
    </div>
  </main>
  </div>
</template>

<script>
/* eslint-disable */
import HeaderMobile from "@/components/Partials/headerMobile";
import SidebarMobile from "@/components/Containers/sidebarMobile";

export default {
  name: "App",
  components: {
    HeaderMobile,
    SidebarMobile,
  },
  computed: {
    list: function() {
      return this.$route.matched.filter(route => route.name);
      // return [];
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Containers/LandingMobile.vue